module.exports = __webpack_public_path__ + "static/tulsa-1.23a9fe62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tulsa-1.jpg
// module id = 497
// module chunks = 155329947031394